export const isAtLeastOneFunctionTruthy = (functionList, ...params) => {

  return functionList?.reduce((prev, curr) => {

    return curr(...params) || prev;
  
  }, false);

};
export const startsWithOneElementFromArray = (needle, haystack) => {

  return haystack?.reduce((prev, curr) => needle.startsWith(curr) || prev, false);

};
